import Landing from '../components/Landing';
import NotFound from '../components/NotFound';

const publicRoutes = [
    { path: '/', component: Landing },
    { path: '*', component: NotFound },
];

const privateRoutes = [];

export { publicRoutes, privateRoutes };
